import {Entity} from '../core/main.entity';

export class CustomerGroup extends Entity {
  id: number;
  title: string;
}
